<style scoped>
	.commonly-menu {
		width: 100%;
		height: 100%;
	}

	.no-data-content {
		width: 100%;
		height: 100%;
		display: flex;
		text-align: center;
		justify-content: center;
		align-items: center;
	}

	.commonly-menu-content {
		display: grid;
		grid-template-columns: repeat(auto-fill, 130px);
		justify-content: center;
	}

	.commonly-menu-item {
		text-align: center;
		color: #737171;
		font-size: 14px;
		width: 90px;
		height: 80px;
		margin: 10px;
		padding: 10px;
		cursor: pointer;
		position: relative;
		display: inline-grid;
		place-items: center;
	}

	.commonly-menu-item-delete {
		position: absolute;
		right: 0;
		top: 0;
		display: none;
		cursor: pointer;
		color: #F56C6C;
		font-size: 18px;
	}

	.commonly-menu-image {
		width: 32px;
		height: 32px;
		display: inline-block;
	}

	.commonly-menu-selected-image {
		width: 32px;
		height: 32px;
		display: none;
	}

	.commonly-menu-item:hover .commonly-menu-item-delete {
		display: block;
	}

	.commonly-menu-item:hover .commonly-menu-image {
		display: none;
	}

	.commonly-menu-item:hover .commonly-menu-selected-image {
		display: inline-block;
	}

	.commonly-menu-item:hover {
		color: #1E40AF;
	}
</style>

<template>
	<div class="commonly-menu">
		<div v-if="currMenuList && currMenuList.length >0" class="commonly-menu-content">
			<div v-for="(item,index) in currMenuList" :key="index" class="commonly-menu-item" @click="$router.replace(item.path)">
				<i class="el-icon-circle-close commonly-menu-item-delete" @click.stop="handleDeleteMenu(item)"></i>
					<img class="commonly-menu-image" :src="item.icon">
					<img class="commonly-menu-selected-image" :src="item.selectIcon" >
					<div>{{ item.title }}</div>
			</div>
		</div>
		<div v-else class="no-data-content">
			<div style="display: inline-block">
				<img src="@/assets/structure/home/no-data.png">
        <div style="color: gray">点击<el-link type="primary" style="font-size: 14px;" @click.stop="handleAdd">『新增』</el-link>，收藏⭐快捷菜单...</div>
			</div>
		</div>
	</div>

</template>


<script>
import {
		menuList, hideMenuList
	} from '@/utils/commonlyMenu';
import {CompanyApi} from "@/api/server/company";
	export default {
		components: {},
		data() {
			return {
				currMenuList: []
			};
		},
		created() {

		},
		mounted() {
		 },
		methods: {
			//移除菜单
			handleDeleteMenu(item) {
				this.$emit("handleRemoveMenu",item.id)
				this.$message.success("删除 [" + item.title + "] 成功")
			},
			//显示菜单
			async handleChangeMenu(selectedList) {
        const response = await CompanyApi.queryCurrentCompany();
        let {code, data} = response;
        const systemVersionType = data?.systemVersionType || 1;
        const list = systemVersionType == 1? menuList.filter(item => !hideMenuList.includes(item.id)):menuList;
				this.currMenuList = list.filter(item => selectedList.includes(item.id));
			},
      handleAdd(){
				this.$emit("handleAddMenu")
			},
		}
	};
</script>